const Roles = {
    ADMIN        : 'admin',
    MARKETER     : 'marketer',
    SUBSCRIBER   : 'subscriber',
    AGENCY       : 'agency',
    MASTER_ADMIN : 'master_admin'
}

const UsedFor = {
    BUSINESS : 'business',
    TESTING  : 'testing'
}

const CreatedFor = {
    PERSONAL : 'personal',
    CLIENT   : 'client'
}

const User = {
    Roles,
    UsedFor,
    CreatedFor
}

export default User